import { defineMessages } from 'react-intl';

export const feelSupportedSectioni18n = defineMessages({
	feelSupportSectionHeader: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.Header',
		defaultMessage: 'Feel supported every step of the way',
	},
	atlassianCommunityInfoCardTitle: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Title',
		defaultMessage: 'Atlassian Community',
	},
	atlassianCommunityInfoCardParagraph: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Paragraph',
		defaultMessage: 'Your questions, answered by our community of experts',
	},
	atlassianCommunityInfoCardCallToActionText: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.CallToAction.Text',
		defaultMessage: 'Join now',
	},
	useCasesInfoCardTitle: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Title',
		defaultMessage: 'Use cases',
	},
	useCasesInfoCardParagraph: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Paragraph',
		defaultMessage: 'How different industries & teams use Confluence',
	},
	useCasesInfoCardCallToActionText: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.CallToAction.Text',
		defaultMessage: 'Learn more',
	},
	videoWalkthroughsInfoCardTitle: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Title',
		defaultMessage: 'Video walkthroughs',
	},
	videoWalkthroughsInfoCardParagraph: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Paragraph',
		defaultMessage: 'Visual explanations for features & setup steps',
	},
	videoWalkthroughsInfoCardCallToActionText: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.CallToAction.Text',
		defaultMessage: 'Watch now',
	},
	productGuidesInfoCardTitle: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Title',
		defaultMessage: 'User guides',
	},
	productGuidesInfoCardParagraph: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Paragraph',
		defaultMessage: 'In-depth guides to help build your Confluence expertise',
	},
	productGuidesInfoCardCallToActionText: {
		id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.CallToAction.Text',
		defaultMessage: 'Read more',
	},
});
